import type {ReactElement} from 'react';
import React from 'react';
import type { VideoSlideListItem} from '@Components/contextual-menu/components/slideshow-list-item/slideshow-list-item.types';
import {SlideShowItemType} from '@Components/contextual-menu/components/slideshow-list-item/slideshow-list-item.types';
import {SlideshowListItem} from '@Components/contextual-menu/components/slideshow-list-item';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import styles from './video-slide-item.module.scss';

export function VideoSlideItem({className = '', isSelected = false, ...props}: Omit<VideoSlideListItem, 'type'>): ReactElement<any> {
  const getContainer = (): ReactElement<any> => {
    return (
      <div className={`flex-center ${styles.mediaContainer} radius-4 `}>
        <Icon icon="icon-videocam" className={`color-extra-light ${styles.mediaContainerIcons}`} size={IconSize.SIZE_ICON_20} />
        <img src={props.videoSrc} alt={window.i18next.t('pmwjs_video')} className={`${styles.mediaSource} radius-4`} />
      </div>
    );
  };
  return (
    <SlideshowListItem
      type={SlideShowItemType.VIDEO}
      onClick={(id: string): void => {
        props.onClick(id);
      }}
      onDelete={(id: string): void => {
        props.onDelete(id);
      }}
      element={getContainer()}
      id={props.id}
      index={props.index}
      className={className}
      isSelected={isSelected}
      duration={props.duration}
    />
  );
}
